import { LoadSpinner } from '@calizahq/react-components-v2'
import React, { useMemo } from 'react'

import { NoResults, Table } from '@/components'
import ListFilter, { FilterTypes } from '@/components/ListFilter/ListFilter'
import { useMobile } from '@/hooks'
import useProperties from '@/hooks/useProperties/useProperties'

import MobilePropertyCard from './MobilePropertyCard'
import { PropertyListColumns } from './Properties.data'

export function Properties() {
  const propertiesQuery = useProperties()
  const properties = propertiesQuery?.data?.properties

  const { isMobile } = useMobile()

  const data = useMemo(() => {
    return properties && properties?.length > 0 ? properties : []
  }, [properties])

  const columns = useMemo(() => {
    return PropertyListColumns
  }, [])

  return (
    <div className="flex w-full flex-col p-4 md:p-8">
      <ListFilter
        hideLengthOfStayFilter={true}
        hideReservationMoveInFilter={true}
        hideReservationMoveOutFilter={true}
        hideSearch={false}
        listType={FilterTypes.PROPERTIES}
        title="Properties"
      />
      {propertiesQuery?.isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          {isMobile ? (
            properties && properties?.length > 0 ? (
              properties?.map((property, i) => <MobilePropertyCard key={`${property?.id}${i}`} property={property} />)
            ) : (
              <NoResults />
            )
          ) : (
            <Table className={''} columns={columns as any} data={data} />
          )}
        </>
      )}
    </div>
  )
}
